<template>
<div class="app">
    <div class="header">
        <div class="icons-submenu">
            <div class="defaultheader icon-submenu" v-bind:class="{active: viewMode == 1}" @click="viewMode = 1">
                <div class="label">Schicht Templates</div>
            </div>
            <div class="defaultheader icon-submenu last" v-bind:class="{active: viewMode == 2}" @click="viewMode = 2">
                <div class="label">Plan-Schichten</div>
            </div>
        </div>

        
        
    </div>
    <templateview v-if="viewMode == 1"></templateview>
    <b-container fluid class="scrollbar-container has-header-important" v-if="viewMode == 2">

        <b-row >
            <b-col>
                <planshifts></planshifts>
            </b-col>
        </b-row>
        
        <br>
    </b-container>
</div>
</template>

<script>

//import shifttemplateoverview from '../shiftcontext/ShiftTemplateOverview.vue'
import templateview from '../shiftcontext/TemplateView.vue'
import planshifts from '../shiftcontext/PlanShiftOverview.vue'


export default {
    components: {
        templateview,
        planshifts
    },
    name: 'ShiftMain',
    data() {
        return {
            viewMode: this.mode == null ? 1 : this.mode,
            loading: true,
        }
    },
    watch: {},
    props: ['mode'],
    created() {
        
    },
    mounted(){
        
    },
    updated() {},
    destroyed() {},
    methods: {
        
    }
}
</script>